var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"rootEl",class:[
    _vm.isPhone && 'is-phone',
    'wrapper',
    'flex-1',
    _setup.displayedState === _setup.ModalState.Minimized && ['min-w-0', 'max-w-41'],
    _setup.displayedState === _setup.ModalState.Docked && ['min-w-101', 'max-w-101'],
    _setup.displayedState === _setup.ModalState.Expanded && ['-me-[var(--gap-between-modals-in-dock)]', 'min-w-0', 'max-w-0'],
    'motion-reduce:!transition-none',
    _setup.transitionClasses,
  ],style:(_setup.customCssProperties),attrs:{"data-dir":// We only want to read this value from CSS, not want it to affect the layout
    // -> Use `data-dir` instead of `dir`.
    _vm.dir}},[_c('div',{ref:"modalContainer",class:[
      'modal-container',
      'flex',
      _setup.displayedState === _setup.ModalState.Minimized && ['min-w-full', 'max-w-full', 'min-h-10', 'max-h-10'],
      _setup.displayedState === _setup.ModalState.Docked && [
        'min-w-full',
        'max-w-full',
        'min-h-0',
        'max-h-[calc(var(--container-height)-var(--bottom-padding)-64px)]',
      ],
      _setup.displayedState === _setup.ModalState.Expanded &&
        !_vm.isPhone && [
          'absolute',
          'bottom-0',
          'end-0',
          'translate-to-center',
          {
            'min-w-135 max-w-135': !_vm.isWide,
            'min-w-[828px] max-w-[828px]': _vm.isWide,
            'transition-[min-width,max-width] duration-200': _setup.isTransitionEnded,
          },
          'min-h-0',
          'max-h-[calc(var(--container-height)-128px)]',
        ],
      _setup.displayedState === _setup.ModalState.Expanded &&
        _vm.isPhone && [
          'absolute',
          'bottom-0',
          'inset-x-0',
          'min-w-[var(--container-width)]',
          'max-w-[var(--container-width)]',
          'min-h-[var(--container-height)]',
          'max-h-[var(--container-height)]',
          // This component should not know how it's being used, but I feel necessary to
          // leave this comment here for the context why we only transition the min/max
          // height on phone expanded layout.
          // We do it to support the post composer in submission request where we can
          // collapse it to see the surface header underneath.
          'transition-[min-height,max-height] duration-200',
        ],
      'motion-reduce:!transition-none',
    ]},[(_setup.xMinimizedContent)?_vm._t("minimized-content"):_c(_setup.displayedState === _setup.ModalState.Expanded ? _setup.OzFocusTrap : 'div',{tag:"component",staticClass:"grow flex min-w-0 modal-content",attrs:{"aria-describedby":_setup.displayedState === _setup.ModalState.Expanded ? _setup.focusTrapDescriptionId : undefined}},[_vm._t("main-content",null,{"isTransitioning":_setup.isTransitionEnded === false}),_vm._v(" "),(_setup.displayedState === _setup.ModalState.Expanded)?_c('p',{staticClass:"sr-only",attrs:{"id":_setup.focusTrapDescriptionId}},[_vm._v("\n        "+_vm._s(_vm.__('Press the Escape key to exit this dialog'))+"\n      ")]):_vm._e()],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }